const flags = {
	features: {
		isPreview: false,
		showSignup: true,
		showServiceDesk: false
	}
};

export default flags;
